import { Injectable, EventEmitter, Inject } from '@angular/core';
import { AuthService } from './auth.service';
import { NotificationToastService } from './notification-toast.service';
// declare the global variables
declare var $: any;

@Injectable()
export class AssistantHubService {

  private proxy: any;
  private proxyName = 'assistantHub';
  private connection: any;
  public onReceiveMessage: any;
  public connectionEstablished: EventEmitter<boolean>;
  public connectionExists: boolean;

  constructor(@Inject('BASE_URL') private baseUrl: string
    , private authService: AuthService
    , private notificationToastService: NotificationToastService) {
    // Constructor initialization
    this.createHubProxyAndStarConnection();
  }

  private createHubProxyAndStarConnection() {
    this.connectionEstablished = new EventEmitter<boolean>();
    this.connectionExists = false;
    // create hub connection
    this.connection = $.hubConnection('http://localhost:1400/signalr');
    // create new proxy as name already given in top
    this.proxy = this.connection.createHubProxy(this.proxyName);
    // register on server events
    this.registerOnServerEvents();
    // call the connecion start method to start the connection to send and receive events.
    this.startConnection();

    // this.connection.disconnected(() => {
    //   this.connectionExists = false;
    //   setTimeout(() => {
    //     if (this.connectionExists === false) {
    //       this.startConnection();
    //     }
    //   }, 5000);
    // });
  }

  public isConnected(): boolean {
    return this.connectionExists;
  }

  public sendMessage(message: string) {
    // server side hub method using proxy.invoke with method name pass as param
    if (this.connectionExists) {
      this.proxy.invoke('SendMessage', message);
    }
  }

  private startConnection(): void {
    this.connection.start().done((data: any) => {
      this.connectionEstablished.emit(true);
      this.connectionExists = true;
    }).fail((error: any) => {
      this.connectionEstablished.emit(false);
    });
  }

  registerOnReceiveMessage(func: any) {
    this.onReceiveMessage = func;
  }

  private registerOnServerEvents(): void {
    this.proxy.on('receiveMessage', (message) => {
      if (this.registerOnReceiveMessage) {
        this.onReceiveMessage(message);
      }
    });
  }
}
